import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IDefaultLogLevelsService = ( createDecorator('IDefaultLogLevelsService'));
export { IDefaultLogLevelsService };
